import { createFileRoute } from '@tanstack/react-router'

import { DashboardPage } from '@/features/dashboard/components/DashboardPage'
import { setupSearchSchema } from '@/features/connect/setup'
import { groupsInfiniteQueryOptions } from '@/features/group/queries'
import { orderListQueryOptions } from '@/features/order-list/queries'
import { DASHBOARD_ORDERS_PAGE_SIZE } from '@/features/dashboard/orders'

export const Route = createFileRoute('/_authed/dashboard')({
  validateSearch: setupSearchSchema,
  shouldReload: ({ cause }) => cause !== 'stay',
  loader: async ({ context }) => {
    // Query retains the error so the dashboard can render its own retry action.
    await Promise.all([
      context.queryClient.infiniteQuery(groupsInfiniteQueryOptions()).catch(() => undefined),
      context.queryClient.prefetchQuery({
        ...orderListQueryOptions({ page: 1, perPage: DASHBOARD_ORDERS_PAGE_SIZE }),
        staleTime: 30_000,
      }),
    ])
  },
  component: DashboardPage,
})
